export default __webpack_public_path__ + "static/media/672.e75d5b42.gif";